// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BkflX-IconViewResponse-module_root{display:flex;align-items:center;justify-content:center;width:6.6666666667rem;height:6.6666666667rem;border-radius:50%}.PBidV-IconViewResponse-module_view_success{background-color:var(--success)}.TwPjG-IconViewResponse-module_view_error{background-color:var(--danger)}.CJT_W-IconViewResponse-module_view_default{background-color:var(--content1)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "BkflX-IconViewResponse-module_root",
	"view_success": "PBidV-IconViewResponse-module_view_success",
	"view_error": "TwPjG-IconViewResponse-module_view_error",
	"view_default": "CJT_W-IconViewResponse-module_view_default"
};
export default ___CSS_LOADER_EXPORT___;
